export default {
  methods: {
    flattenObject: function (object) {
      const result = {}

      function flatten(obj, prefix = '') {
        _.forEach(obj, (value, key) => {
          if (_.isObject(value)) {
            flatten(value, `${prefix}${key}.`)
          } else if (key != '_id') {
            result[`${prefix}${key}`] = value
          }
        })
      }

      flatten(object)

      return result
    },
  },
}
